import { render, staticRenderFns } from "./VIPMiddlePay.vue?vue&type=template&id=68171b18&scoped=true&"
import script from "./VIPMiddlePay.vue?vue&type=script&lang=js&"
export * from "./VIPMiddlePay.vue?vue&type=script&lang=js&"
import style0 from "./VIPMiddlePay.vue?vue&type=style&index=0&id=68171b18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68171b18",
  null
  
)

export default component.exports